// with polyfills
import '@babel/polyfill'
// 以前的方式
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import moment from 'moment'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from '@/utils/request' // axios 不建议引入到 Vue 原型链上
import VueI18n from 'vue-i18n'
import { USER_LANGUAGE } from '@/store/mutation-types'

import './core/use'
import bootstrap from './core/bootstrap'
import '@/permission' // permission control
import '@/utils/filter' // global filter
import draggable from 'vuedraggable'
import DateTimeUtil from '@/utils/datetime-util'
import { capitalize } from '@/utils/util'
import { Icon } from 'ant-design-vue'

Vue.config.productionTip = false
window.Vue = Vue

Vue.use(VueI18n)
Vue.use(VueAxios, router)
Vue.use(draggable)

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2548774_fuv0qv3bimj.js?spm=a313x.7781069.1998910419.41&file=font_2548774_fuv0qv3bimj.js',
})

Vue.use(IconFont)

Vue.mixin({
  components: {
    IconFont,
  },
  methods: {
    // 处理业务异常
    mixinProcessHasBizErrorNotification (res) {
      // 发生业务异常
      if (res.success === false) {
        this.$notification['warning']({
          message: 'Warning',
          description: `error:${res.errorCode}, errorMessage:${res.errorMessage}`
        })
        return true
      }
      return false
    },
    // 公共业务成功方法
    mixinProcessSuccessNotification (msg) {
      this.$notification['success']({
        message: 'Sussess',
        description: msg
      })
    },
    // 非业务异常
    mixinNotBizErrorNotification (e) {
      console.log('error', e)
      this.$notification['error']({
        message: 'Error',
        description: `System error ${e.message}`
      })
    },
    // 处理await方式返回的异常
    mixinNotBizErrorResponseNotification (e) {
      let message = ''
      if(e.response && e.response.data) {
        message = e.response && e.response.data.errorMessage
      }
      this.$notification['error']({
        message: 'Error',
        description: `System error ${message}`
      })
    },
    // 日期格式化
    dateFormat (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      }
      return ''
    },
    // 日期格式化
    dateFormatB (date) {
      if (date) {
        return moment(date).format('MM/DD/YYYY')
      }
      return ''
    },
    // 日期时间格式化
    dateTimeFormat (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD hh:mm:ss')
      }
      return ''
    },
    // 日期时间格式化
    dateTimeFormatB (date) {
      if (date) {
        return moment(date).format('MM/DD/YYYY hh:mm:ss')
      }
      return ''
    },
    // 首字母大写
    capitalize,
    DateTimeUtil () {
      return DateTimeUtil
    },
    // 使用JSON stringify parse深拷贝对象
    copyDataByJSON (data) {
      return JSON.parse(JSON.stringify(data))
    },
    // 生成uuid 暂时用事件戳代替
    generateUuid() {
      return (new Date().getTime()) + ''
    },
    // 金额带千分位格式化
    moneyFormatThousand(s) {
      if (!s || s === '' || s === 0) {
        return s
      }
      let isNeg = false
      s = s + ''
      if (s.startsWith('-')) {
        s = s.substr(1)
        isNeg = true
      }
      const dot = ','
      s = parseFloat((s + '').replace(/[^\d.-]/g, '')).toFixed(2) + ''
      var l = s.split('.')[0].split('').reverse(),
      r = s.split('.')[1]
      let t = ''
      for(let i = 0; i < l.length; i ++ )   {
         t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? dot : '')
      }
      const result = (isNeg ? '-' : '') + t.split('').reverse().join('') + '.' + r
      // result = result.replace('.00', '')
      return result
    },
    moneyFormatThousandNoZero (s) {
      s = this.moneyFormatThousand(s)
      if (s) {
        // s = s.replace('.00$', '')
        // s = s.replace('.0$', '')
        // s = s.replace(/\.00$/, '')
        // s = s.replace(/\.0$/, '')
        s = s.replace(/\.0+$/, '').replace(/(\.[\d]*?)0+$/g, '$1')
      }
      return s
    },
    // 字符串是否为空
    isStrEmpty (str) {
      return !str || str == null || str === '' || str == undefined
    },
    // 获取唯一名称用斜杠分隔
    singleNameA (twName, enName) {
      let showName = ''
      if (!this.isStrEmpty(twName) && !this.isStrEmpty(enName)) {
        // 如果同时有中英文名称
        showName = twName
        if (twName !== enName) {
          // 如果中英文名不一致
          showName = twName + '/' + enName
        } else {
          // 如果中英文名一致
          showName = twName
        }
      } else if (!this.isStrEmpty(twName)) {
        // 只有中文名
        showName = twName
      } else if (!this.isStrEmpty(enName)) {
        // 只有英文名
        showName = enName
      } else {
        showName = ''
      }
      return showName
    },
    isEnvProd () {
      return process.env.VUE_APP_BUILD_TARGET === 'prod'
    },
  }
})

var lang = navigator.language || navigator.userLanguage
if (lang.substr(0, 3) === 'zh-') {
  lang = 'zh-TW'
} else {
  lang = 'en-US'
}
// 如果用户已设置语言，那么采用用户设置的语言
if (Vue.ls.get(USER_LANGUAGE)) {
  const userLang = Vue.ls.get(USER_LANGUAGE)
  if (userLang === 'en') {
    lang = 'en-US'
  } else {
    lang = 'zh-TW'
  }
}
lang = 'en-US'

/* 语言切换 */
const i18n = new VueI18n({
  // locale: LangStorage.getLang('zh'),  // 语言标识，后面会用做切换和将用户习惯存储到本地浏览器
  locale: lang, // 语言标识
  messages: {
    'zh-TW': require('./i18n/zh-TW'),
    'en-US': require('./i18n/en-US')
  }
})

new Vue({
  router,
  store,
  i18n,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
